// extracted by mini-css-extract-plugin
export var borderRadius = "_ev-4";
export var large = "_ev-3";
export var logoContainer = "_ev-0";
export var nameLogo = "_ev-2";
export var small = "_ev-1";